import React, { forwardRef } from "react";

import { Field, getIn, FieldProps } from "formik";
import { dissoc } from "ramda";

import { Input, InputProps } from "src/components/Input";

export interface FormikInputProps extends Omit<InputProps, "name"> {
  /** Formik field name. */
  name: string;
}

const FormikInput = forwardRef<HTMLInputElement, FormikInputProps>(
  ({ name, onChange: onChangeProp, ...rest }, ref) => (
    <Field name={name}>
      {({ field, meta, form }: FieldProps) => {
        const { status = {}, setStatus } = form;
        const fieldStatus = getIn(status, name);

        const fieldProps = {
          ...field,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            setStatus(dissoc(name, status));
            field.onChange(e);
            onChangeProp?.(e);
          },
        };

        return (
          <Input
            ref={ref}
            {...fieldProps}
            error={meta.touched ? meta.error || fieldStatus : ""}
            {...rest}
          />
        );
      }}
    </Field>
  )
);

FormikInput.displayName = "FormikInput";

export { FormikInput };
